import { getPathParams, getResolvedPathAndParameters, isDefined, isPathReady } from './index.js';
function getParametersByName(names, parameters) {
    return names.reduce((accumulator, name) => ({
        ...accumulator,
        [name]: parameters[name],
    }), {});
}
function getRequestParameters(options, contextData) {
    const { endpoint, limit, page, parameters } = options;
    const names = getPathParams(endpoint);
    const contextParameters = getParametersByName(names, contextData);
    const requestParameters = { ...parameters };
    if (isDefined(page) && page !== null) {
        requestParameters['page'] = page;
    }
    if (isDefined(limit) && limit !== null) {
        requestParameters['limit'] = limit;
    }
    return {
        ...contextParameters,
        ...requestParameters,
    };
}
function isEndpointReady(options, contextData) {
    const { endpoint } = options;
    const { resolvedPath } = getResolvedPathAndParameters(endpoint, getRequestParameters(options, contextData));
    return isPathReady(resolvedPath);
}
export { getParametersByName, getRequestParameters, isEndpointReady, };
//# sourceMappingURL=request.js.map